var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import ImageLoader from "./ImageLoader.js";
import SpriteLoader from "./SpriteLoader.js";
import MapLoader from "./MapLoader.js";
import RAPIER from "@dimforge/rapier2d-compat";
import { Persist } from "../persist/persist.js";
import { PixiSpineLoader } from "./PixiSpineLoader.js";
import { s as setGlobalSingleton, a as assignGlobalSingleton } from "../global-33d5eebf.js";
import * as PIXI from "pixi.js";
import { PixiSoundLoader } from "./SoundLoader.js";
import "./PixiSpriteLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "pixi-spine";
import "../_commonjsHelpers-7a77ea84.js";
const n = (name) => name == null ? void 0 : name.toLowerCase().replace(/ /g, "_");
setGlobalSingleton("RAPIER", RAPIER);
setGlobalSingleton("PIXI", PIXI);
class AssetLoader {
  constructor() {
    __publicField(this, "assetCache", {});
    __publicField(this, "uiCache", {});
  }
  static getInstance() {
    return assignGlobalSingleton("assetLoader", () => new AssetLoader());
  }
  async load() {
    const assetPromises = Object.values(this.assetCache).map((asset) => asset.promise);
    await Promise.all(assetPromises);
    await RAPIER.init();
    await Persist.getInstance().init();
    try {
      await SpriteLoader.getInstance().waitForAll();
    } catch (e) {
      console.error(e);
      throw e;
    }
    return true;
  }
  async loadUi(name, ui) {
    this.assetCache[n(name)] = {
      type: 4,
      promise: Promise.resolve(n(name))
    };
    this.uiCache[n(name)] = ui;
    return this.assetCache[n(name)].promise;
  }
  async loadImage(name, urlOrOptions, options) {
    let url;
    if (typeof urlOrOptions === "string") {
      url = urlOrOptions;
    } else if (urlOrOptions) {
      options = urlOrOptions;
    }
    if (!url) {
      url = name + ".png";
    }
    const assetPath = `assets/images/${url}`;
    this.assetCache[n(name)] = {
      type: 0,
      promise: ImageLoader.getInstance().loadImage(n(name), assetPath, options).then(() => n(name))
    };
    return this.assetCache[n(name)].promise;
  }
  async loadSprite(name, url, options) {
    const assetPath = `assets/images/${url}`;
    this.assetCache[n(name)] = {
      type: 1,
      promise: SpriteLoader.getInstance().loadSprite(n(name), assetPath, options).then(() => n(name))
    };
    return this.assetCache[n(name)].promise;
  }
  async loadSpine(name, url) {
    const assetPath = `assets/spine/${url}`;
    this.assetCache[n(name)] = {
      type: 2,
      promise: PixiSpineLoader.getInstance().loadSpine(n(name), assetPath).then(() => n(name))
    };
    return this.assetCache[n(name)].promise;
  }
  async loadMap(name, url) {
    const assetPath = `assets/maps/${url}`;
    this.assetCache[n(name)] = {
      type: 1,
      promise: MapLoader.getInstance().loadMap(n(name), assetPath).then(() => n(name))
    };
    return this.assetCache[n(name)].promise;
  }
  async loadMapSkin(name, url) {
    const assetPath = `assets/maps/${url}`;
    this.assetCache[n(name)] = {
      type: 1,
      promise: MapLoader.getInstance().loadSkin(n(name), assetPath).then(() => n(name))
    };
    return this.assetCache[n(name)].promise;
  }
  async loadSound(name, url, soundOptions) {
    const assetPath = `assets/sounds/${url}`;
    this.assetCache[n(name)] = {
      type: 3,
      promise: PixiSoundLoader.getInstance().loadSound(n(name), assetPath, soundOptions).then(() => n(name))
    };
    return this.assetCache[n(name)].promise;
  }
  getUi(name) {
    return JSON.parse(JSON.stringify(this.uiCache[n(name)]));
  }
  getImage(name) {
    return ImageLoader.getInstance().get(n(name));
  }
  getSprite(name, index) {
    return SpriteLoader.getInstance().get(n(name), index);
  }
  getSound(name) {
    return PixiSoundLoader.getInstance().get(n(name));
  }
  getMap(name) {
    return MapLoader.getInstance().get(n(name));
  }
  getMapSkin(name) {
    return MapLoader.getInstance().getSkin(name);
  }
}
export {
  AssetLoader as default
};
//# sourceMappingURL=AssetLoader.js.map
